export default [{
    path: '/palletizado/imprimirEtiqueta',
    name: 'palletizado-generar-etiqueta',
    component: () =>
        import ('@/views/pages/palletizado/Palletizado.vue'),
    meta: {
			title: 'i18n:',
        resource: 'Palletizado',
        action: 'ver-palletizado-generar-etiqueta',
        pageTitle: 'Imprimir Etiqueta',
        breadcrumb: [
            {
                text: "Mantenimiento"
            },
            {
            text: 'Imprimir Etiqueta',
            active: true,
            },
        ],
    }
},
{
    path: '/palletizado/reservacionEtiqueta',
    name: 'palletizado-reversar-etiqueta',
    component: () =>
        import ('@/views/pages/palletizado/ReservacionEtiqueta.vue'),
    meta: {
			title: 'i18n:',
        resource: 'Palletizado',
        action: 'ver-palletizado-reversar-etiqueta',
        pageTitle: 'Reservación de Etiquetas',
        breadcrumb: [
            {
                text: "Mantenimiento"
            },
            {
            text: 'Reservación de Etiquetas',
            active: true,
            },
        ],
    }
},
{
    path: '/palletizado/aprobarPallet',
    name: 'palletizado-aprobar-pallet',
    component: () => 
        import('@/views/pages/palletizado/AprobarPallet.vue'),
    meta: {
        title: 'Aprobar Pallet',
        resource: 'Palletizado',
        action: 'ver-palletizado-aprobar-pallet',
        pageTitle: 'Aprobar Pallet',
        breadcrumb: [
            {
                text: "Palletizado"
            },
            {
                text: "Transacciones"
            },
            {
            text: 'Aprobar Pallet',
            active: true,
            },
        ],
    },
},
{
    path: '/palletizado/reporte/layoutCamara',
    name: 'palletizado-stock',
    component: () =>
        import ('@/views/pages/palletizado/PalletizadoStock.vue'),
    meta: {
			title: 'i18n:',
        resource: 'Palletizado',
        action: 'ver-palletizado-stock-pallet',
        pageTitle: 'Reporte Layout Camara',
        breadcrumb: [
            {
                text: "Palletizado"
            },
            {
                text: "Informes"
            },
            {
            text: 'Layout Camara',
            active: true,
            },
        ],
    }
},{
    path: '/palletizado/reporte/movimientosCamara',
    name: 'palletizado-movimiento',
    component: () =>
        import ('@/views/pages/palletizado/PalletizadoMovimiento.vue'),
    meta: {
			title: 'i18n:',
        resource: 'Palletizado',
        action: 'ver-palletizado-reporte-movimientos',
        pageTitle: 'Movimiento en Camaras',
        breadcrumb: [
            {
                text: "Palletizado"
            },
            {
                text: "Informes"
            },
            {
            text: 'Movimiento Camaras',
            active: true,
            },
        ],
    }
},


]
